import React, { useEffect, useState } from 'react';
import { api, btnPrimary, InlineError, input, labelCls, useToast } from '../ui/Kit';

// Part B: your own Teams / Zoom / Meet link — it pre-fills the meeting link of video rounds you lead (editable there)
export function MeetingLinkForm() {
  const toast = useToast();
  const [link, setLink] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => { api('/api/me/meeting-link').then((d) => setLink(d.meeting_link || '')).catch((e) => setError(e.message)); }, []);
  const save = async () => {
    setError('');
    try { const d = await api('/api/me/meeting-link', { method: 'PUT', body: { meeting_link: link.trim() || null } }); setLink(d.meeting_link || ''); toast.show('Meeting link saved'); }
    catch (e) { setError(e.message); }
  };
  if (link === null) return error ? <InlineError>{error}</InlineError> : null;
  return (
    <div data-testid="meeting-link-form">
      <label className="block"><span className={labelCls}>Personal meeting link (Teams, Zoom or Meet)</span>
        <input className={input} value={link} placeholder="https://…" onChange={(e) => setLink(e.target.value)} data-testid="meeting-link-input" />
        <span className="block text-xs text-[#64748B] mt-1" data-testid="meeting-link-hint">Used when you’re the lead interviewer on a video round.</span></label>
      <div className="flex justify-end mt-3"><button className={btnPrimary} onClick={save} data-testid="meeting-link-save">Save link</button></div>
      <InlineError>{error}</InlineError>
    </div>
  );
}
